import { webAPI } from '../../../axiosInstance';


const getOneBrand = async (brandId: any) => {
  const response = await webAPI.get(`/brands/${brandId}`);
  return response.data;
};


const editBrand = async (data: any) => {
  const response = await webAPI.put(`/brands/edit/${data?.brandId}`, data?.formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export { getOneBrand, editBrand };
